import React from "react";
import NewsDetailContainer from "../containers/NewsDetailContainer";

export default function NewsDetail() {
  return <NewsDetailContainer />;
}
